import { render, staticRenderFns } from "./ProvenanceTable.vue?vue&type=template&id=8deb5518&"
import script from "./ProvenanceTable.vue?vue&type=script&lang=js&"
export * from "./ProvenanceTable.vue?vue&type=script&lang=js&"
import style0 from "./ProvenanceTable.vue?vue&type=style&index=0&id=8deb5518&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports